import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import Ball from "../Ball";
// import cancelImg from "./img/cancel.png";

const Player = ({
  id,
  bet,
  index,
  balls,
  cancelHandlerClick,
  shouldCanRemove,
  win,
}) => {
  const className = win ? "win bet" : "bet";
  const className1 = win ? "win bet" : "bet";
  return (
    <Fragment>
      <tr className={className}>
        <td>
          <div>{`№${id}`}</div>
        </td>
        <td>
          <div className="balls">
            {balls?.map((ball) => (
              <Ball number={ball} />
            ))}
          </div>
        </td>
        <td className={className1}>
          <div className="playerBet">
            {bet ? `${bet} HTG` : ""}
            {shouldCanRemove && (
              <span className="cancel">
                <img
                  src="/static/images/cancel.png"
                  onClick={() => cancelHandlerClick(id)}
                  alt="cancel"
                />
              </span>
            )}
          </div>
        </td>
      </tr>
    </Fragment>
  );
};
export default Player;
